import { useState } from "react";
import { AddClientModal } from "../../modal";
import { GradientButton } from "../../GradientButton";
import { PlusIcon } from "../../../images";
import { ButtonsColorType } from "../../../../types/enums";
import { useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";

export const AddNewClientBtn = ({
  buttonType,
}: {
  buttonType?: ButtonsColorType;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedShareAccess } = useAppSelector(selectPermissions);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <GradientButton
        onClick={openModal}
        buttonType={buttonType}
        startIcon={
          <PlusIcon color={!isAllowedShareAccess ? "grey" : "white"} />
        }
        disabled={!isAllowedShareAccess}
      >
        Add New Client User
      </GradientButton>
      {isOpen && <AddClientModal onClose={closeModal} />}
    </>
  );
};
